// extracted by mini-css-extract-plugin
export var readonly = "_h4-1";
export var star = "_h4-0";